module.exports = __webpack_public_path__ + "static/media/1.fc0d5d30.svg";